import { render, staticRenderFns } from "./BudgetsByPatent.vue?vue&type=template&id=0f33135d&scoped=true&lang=pug"
import script from "./BudgetsByPatent.vue?vue&type=script&lang=js"
export * from "./BudgetsByPatent.vue?vue&type=script&lang=js"
import style0 from "./BudgetsByPatent.vue?vue&type=style&index=0&id=0f33135d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33135d",
  null
  
)

export default component.exports